import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";

import { DirectivesModule } from "../directives/directives.module";
import { PipesModule } from "../pipes/pipes.module";
import { ProgressSpinnerModule } from "../components/default/progress-spinner/progress-spinner.module";
import { FormModule } from "../components/default/form/form.module";
import { IconModule } from "../components/default/icon/icon.module";
import { TableModule } from "../components/custom/table/table.module";
import { AngularMaterialModule } from "../../core/angular-material/angular-material.module";
import { WindowLoadingModule } from "../components/default/window-loading/window-loading.module";
import { UploadModule } from "../components/default/upload/upload.module";
import { FilePickerModule } from "../components/custom/file-picker/file-picker.module";
import { ConfirmActionModule } from "../components/custom/confirm-action/confirm-action.module";
import { TabsModule } from "../components/custom/tabs/tabs.module";
import { DialogInformationModule } from "../components/custom/dialog-information/dialog-information.module";
import { ListModule } from "../components/custom/list/list.module";
@NgModule({
    declarations: [],
    imports: [],
    exports: [
        CommonModule,
        DirectivesModule,
        PipesModule,
        FormsModule,
        FormModule,
        IconModule,
        ProgressSpinnerModule,
        TableModule,
        ListModule,
        ConfirmActionModule,
        DialogInformationModule,
        TabsModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        WindowLoadingModule,
        TranslateModule,
        UploadModule,
        FilePickerModule,
    ]
})
export class BaseModule{}
